/**
 * Main Application Entry Point
 * Imports and initializes all components and utilities
 */

// Import styles
import './styles/base.css';
import './styles/components.css';
import './styles/responsive.css';

// Import utilities
import { initAnimations } from './utils/animations';

// Import components
import { createHeader } from './components/Header';
import { createHero } from './components/Hero';
import { createInvestmentStrategy } from './components/InvestmentStrategy';
import { createFocusAreas } from './components/FocusAreas';
import { createOurApproach } from './components/OurApproach';
import { createLeadership } from './components/Leadership';
import { createFooter } from './components/Footer';

/**
 * Initialize the application
 * Renders all components and initializes animations
 */
function init(): void {
  const app = document.getElementById('app');

  if (!app) {
    console.error('App container not found');
    return;
  }

  // Render all components
  app.innerHTML = `
    ${createHeader()}
    ${createHero()}
    ${createInvestmentStrategy()}
    ${createFocusAreas()}
    ${createOurApproach()}
    ${createLeadership()}
    ${createFooter()}
  `;

  // Initialize animations and interactions
  initAnimations();

  console.log('✨ Arceus Wealth application initialized');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

export default init;
